export default __webpack_public_path__ + "static/media/Lips-Study-Nate-Baldwin.d17d39fd.jpg";